export default __webpack_public_path__ + "locales/hy-AM/Settings.json?hash=e1911299a848b3877d15e9b1f6cf7eb6";